import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaIndustry, FaCogs, FaHandsHelping, FaTachometerAlt, FaPlay } from 'react-icons/fa';
import CustomBanner from '../Component/custombaneer';
import CustomVideo from '../Component/CustomVideo';
import CustomSlickSlider from '../Component/CustomSlickSlider';
import slidesData from '../LocalDate/slidesData';
import MapaelWorldMap from '../Component/MapaelWorldMap';
import ServiceRequestBanner from '../Component/ServiceRequestBanner';
import VideoModal from '../Component/VideoModal';
import BGIMG from '../assets/imases/about-manufacturing.jpg';
import FancyboxVideoGallery from '../Component/VideoGallery';
import INNER_BANNER from '../assets/imases/meeting.jpg';
import PowermanAbout from '../assets/imases/powermanaboutimg.PNG';

const Company = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <CustomVideo
                videoUrl="https://www.youtube.com/watch?v=Ineyo7s27lo"
            // title="Explore the Future of Tech"
            // linkText="Watch More"
            // linkHref="https://tech.example.com"
            // downloadUrl="https://yourserver.com/videos/future.mp4" // optional
            />

            {/* About Us Section */}
            <Container className="py-5">
                <Row>
                    {/* <Col md={6} data-aos="fade-right">
                        <img src={PowermanAbout} alt="About PowermanIndia" className="img-fluid rounded shadow" />
                    </Col>
                    <Col md={6} data-aos="fade-left">
                        <h2>About PowermanIndia</h2>
                        <p>
                            For over 15 years, Powerman has been a trusted name in the manufacturing, importing, and supplying of industrial air compressors and workshop equipment. Known for reliability, expertise, and innovation, we deliver high-performance solutions that drive efficiency and productivity across industries and workshops.

                        </p>
                        <p>
                            Our product range is designed to meet varied industrial and automotive needs. Belt-driven heavy-duty compressors, screw compressors, and oil-free compressors are widely used in factories, workshops, and production units to power tools, machinery, and critical processes with consistency. In the automotive service sector, our advanced car washers, wheel alignment systems, tyre changers, and wheel balancers ensure accuracy and efficiency in vehicle maintenance. For two-wheeler garages, our lifting equipment offers safety and convenience during repairs and servicing.

                        </p>
                    </Col>

                    <Col md={6} data-aos="fade-left">
                        <h2>About PowermanIndia</h2>
                        <p>
                            We also provide body shop equipment for painting and repair work, cleaning equipment to maintain smart,efficient workplaces, and durable industrial motor cables for safe energy distribution in demanding environments.


                        </p>
                        <p>
                            At Powerman, we believe in going beyond machines. Our commitment to quality, customer satisfaction, and professional support ensures that every product delivers long-term performance and value. More than a supplier, we are a trusted partner—helping businesses work smarter, faster, and with confidence.

                        </p>
                    </Col>
                    <Col md={6} data-aos="fade-right">
                        <img src={PowermanAbout} alt="About PowermanIndia" className="img-fluid rounded shadow" />
                    </Col> */}
                    <div style={{
                        width: '1200px',
                        margin: 'auto',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                    }}>
                        <img src={PowermanAbout} alt="img" style={{
                            width: '100%',
                            height: '300px',
                            marginTop: "15px",
                            borderRadius: '12px',
                        }} />
                        <div style={{ padding: '20px' }}>
                            <h2 style={{ marginBottom: '10px', justifyContent: 'center', display: 'flex' }}>About PowermanIndia</h2>
                            <p style={{
                                textAlign: 'justify',
                                lineHeight: '1.6'
                            }}>

                                <p>
                                    For over 15 years, Powerman has been a trusted name in the manufacturing, importing, and supplying of industrial air compressors and workshop equipment. Known for reliability, expertise, and innovation, we deliver high-performance solutions that drive efficiency and productivity across industries and workshops.

                                </p>
                                <p>
                                    Our product range is designed to meet varied industrial and automotive needs. Belt-driven heavy-duty compressors, screw compressors, and oil-free compressors are widely used in factories, workshops, and production units to power tools, machinery, and critical processes with consistency. In the automotive service sector, our advanced car washers, wheel alignment systems, tyre changers, and wheel balancers ensure accuracy and efficiency in vehicle maintenance. For two-wheeler garages, our lifting equipment offers safety and convenience during repairs and servicing.

                                </p>
                                <p>
                                    We also provide body shop equipment for painting and repair work, cleaning equipment to maintain smart,efficient workplaces, and durable industrial motor cables for safe energy distribution in demanding environments.


                                </p>
                                <p>
                                    At Powerman, we believe in going beyond machines. Our commitment to quality, customer satisfaction, and professional support ensures that every product delivers long-term performance and value. More than a supplier, we are a trusted partner—helping businesses work smarter, faster, and with confidence.

                                </p>
                            </p>
                        </div>
                    </div>

                </Row>
            </Container>

            <Container>
                <CustomSlickSlider slidesData={slidesData} />
            </Container>


            {/* Deming Award Moments Section */}
            <Container className="award_to_company hidden" style={{ marginTop: 100 }} >
                <Row className="text-center mb-4">
                    <Col data-aos="fade-up">
                        <h6 className="text-uppercase text-muted">ALWAYS BETTER. FOR YOU</h6>
                        <h2 className="fw-bold">DEMING AWARD MOMENTS</h2>
                        <p className="text-muted mx-auto" style={{ maxWidth: '800px' }}>
                            At Powerman, achieving the prestigious Deming Award is a proud milestone in our journey of excellence. This recognition reflects our unwavering dedication to quality, innovation, and customer satisfaction. Beyond products, we are equally committed to providing reliable service support, ensuring that every client experiences seamless solutions and lasting trust. The award is a tribute to our team’s efforts, our partners’ confidence, and our focus on continuous improvement. It motivates us to expand our global footprint, deliver end-to-end value, and set higher benchmarks. For Powerman, the Deming Award is not the destination, but a stepping stone toward greater achievements and a brighter, sustainable future.
                        </p>
                    </Col>
                </Row>

                <Row className="g-3 hidden">
                    {[...Array(8)].map((_, index) => (
                        <Col key={index} xs={6} md={3} data-aos="flip-left" data-aos-delay={index * 100}>
                            <div className="award-img-container shadow-sm">
                                <img
                                    src={`https://picsum.photos/seed/${index + 1}/300/200`}
                                    alt={`Award ${index + 1}`}
                                    className="img-fluid w-100"
                                    style={{ objectFit: 'cover', height: '200px' }}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>

            <div className='map_and_gallrey_section hidden'>
                <MapaelWorldMap />
                <FancyboxVideoGallery />
            </div>

            <ServiceRequestBanner
                bgImage={INNER_BANNER}
                headingMain="Ready to power your business with Powerman. "
                description="Click below and let us know your requirements we’ll help you find the perfect solution."
                buttonLabel="APPLY NOW"
                buttonLink="/Career"

            />

        </>
    );
};

export default Company;
